import ROUTE from '../../constants/route';

const FooterLinks = [
  {
    title: 'Recruit',
    items: [
      {
        candidateOnly: true,
        text: 'Jobs',
        to: ROUTE.JOBS,
      },
      {
        candidateOnly: true,
        text: 'Applications',
        to: `${ROUTE.JOBS}?applied`,
      },
      {
        text: 'Inbox',
        href: ROUTE.INBOX,
      },
    ],
  },
  {
    title: 'Account',
    items: [
      {
        candidateOnly: true,
        text: 'Profile',
        href: ROUTE.CANDIDATE_PROFILE,
      },
      {
        text: 'Settings',
        href: ROUTE.CANDIDATE_ACCOUNT,
      },
      {
        text: 'Notifications',
        href: `${ROUTE.CANDIDATE_ACCOUNT}#notifications`,
      },
    ],
  },
  {
    title: 'Contact',
    items: [
      {
        text: 'Platform Support',
        href: '/support',
      },
      {
        text: 'Report a Bug',
        href: '/platform-feedback',
      },
      {
        text: 'Request a Feature',
        href: '/feature-request',
      },
    ],
  },
];

export default FooterLinks;
